import { ChangeDetectorRef, Component } from '@angular/core'
import { GlobalMessageType, Price, RoutingService } from '@spartacus/core'
import { finalize, switchMap } from 'rxjs/operators'
import { CustomRoutes } from '../../../../../models/enum/custom-routes.enum'
import { DispenserCreditClaimHistoryStatus } from '../../../../../models/enum/dispenser.enum'
import { SharedValue } from '../../../../../models/enum/shared.enum'
import { ICsv } from '../../../../../models/interface/csv.interface'
import { ISharedPagination } from '../../../../../models/interface/shared.interface'
import { DispenserAgreementService } from '../../../../../services/agreement/dispenser/dispenser-agreement.service'
import { DispenserShipmentService } from '../../../../../services/agreement/dispenser/dispenser-shipment.service'
import { ShipmentCreditClaimService } from '../../../../../services/agreement/shipment-credit-claim/shipment-credit-claim.service'
import { DocumentService } from '../../../../../services/document.service'
import { CsvService } from '../../../../../services/shared/csv/csv.service'
import { CustomGlobalMessageService } from '../../../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../../../services/shared/shared.service'
import { ICustomSelectOption } from '../../../../shared/custom-components/custom-select/modals/interface/custom-select.interface'
import { CustomTableColumnType } from '../../../../shared/custom-components/custom-table/modals/enum/custom-table.enum'
import { DispenserShipmentHistoryComponent } from '../../dispenser-agreement/dispenser-shipment/dispenser-shipment-history/dispenser-shipment-history.component'

@Component({
    selector: 'app-shipment-credit-claims-history',
    templateUrl: './shipment-credit-claims-history.component.html',
    styleUrls: ['./shipment-credit-claims-history.component.scss'],
    standalone: false
})
export class ShipmentCreditClaimsHistoryComponent extends DispenserShipmentHistoryComponent {
  private dispenserShipmentId: string
  public shipmentEntries: any[]
  public netValue: Price
  public gst: Price
  public dateCreated: Date
  public filterOptions: ICustomSelectOption[] = Object.keys(DispenserCreditClaimHistoryStatus).map((item) => {
    return {
      label: 'dispenserShipment.status.' + item,
      value: item
    }
  })

  constructor(
    dispenserAgreementService: DispenserAgreementService,
    dispenserShipmentService: DispenserShipmentService,
    globalMessageService: CustomGlobalMessageService,
    sharedService: SharedService,
    changeDetectorRef: ChangeDetectorRef,
    routingService: RoutingService,
    csvService: CsvService,
    shipmentCreditClaimService: ShipmentCreditClaimService,
    documentService: DocumentService
  ) {
    super(
      dispenserAgreementService,
      dispenserShipmentService,
      globalMessageService,
      sharedService,
      changeDetectorRef,
      routingService,
      csvService,
      shipmentCreditClaimService,
      documentService
    )
  }

  ngOnInit() {
    // remove address column
    this.headers.splice(2, 1)

    // add columns at the start
    this.headers.splice(1, 0, { title: 'dispenserShipment.creditMemo' }, { title: 'dispenserShipment.agreementNumber' })

    // add columns at the end
    this.headers.splice(
      -1,
      1,
      { title: 'dispenserShipment.gst' },
      { title: 'shared.actions', type: CustomTableColumnType.BUTTONS }
    )

    this.columns = [
      { key: 'code' },
      {
        key: 'orderDocument',
        type: CustomTableColumnType.LINK,
        link: {
          handler: (res) => this.downloadCreditNote(res.orderDocument)
        }
      },
      { key: 'quote.orderCode' },
      { key: 'shipmentOrderDate', type: CustomTableColumnType.DATE },
      { key: 'type', mapWith: 'dispenserShipment.shipTo.' },
      { key: 'status', mapWith: 'dispenserShipment.status.' },
      { key: 'netValue.formattedValue' },
      { key: 'gst.formattedValue' },
      {
        key: 'buttons',
        type: CustomTableColumnType.BUTTONS,
        buttons: [
          {
            title: 'shared.details',
            translate: true,
            icon: 'fa fa-info-circle',
            handler: (res) => this.viewDetails(res)
          },
          {
            key: 'downloadCreditNote',
            title: 'shared.downloadCreditNote',
            translate: true,
            icon: 'fa fa-download',
            handler: (res) => this.downloadCreditNote(res.orderDocument)
          }
        ]
      }
    ]

    this.sharedService
      .getUrlParam('code')
      .pipe(
        switchMap((code) => {
          this.dispenserShipmentId = code
          return this.shipmentCreditClaimService.getShipmentCreditClaimById(code)
        })
      )
      .subscribe((detail) => {
        ;({ netValue: this.netValue, gst: this.gst, dateCreated: this.dateCreated } = detail)

        if (detail.entries?.length) {
          this.agreement = detail.entries[0].quote
          this.agreementCode = this.agreement.orderCode
          this.changeDetectorRef.detectChanges()
        }

        this.sharedService
          .getQueryParams()
          .subscribe((queryParams) => {
            if (queryParams?.page) {
              this.pageChange(queryParams.page)
            } else {
              this.pageChange(1)
            }
          })
          .unsubscribe()
      })
  }

  viewDetails(value: any): void {
    const queryParam = {
      [CustomRoutes.SHIPMENT_CREDIT_CLAIM_HISTORY]: { page: this.selectedPage }
    }
    this.sharedService.setQueryParamsLocal(queryParam)

    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go(
      { cxRoute: CustomRoutes.SHIPMENT_CREDIT_CLAIM_DETAIL },
      // Sagar
      // null,
      {
        queryParams: {
          dispenserShipmentId: this.dispenserShipmentId,
          agreementId: this.agreement.orderCode,
          shipmentId: value?.code
        }
      }
    )
  }

  pageChange(page: number): void {
    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go(
      {
        cxRoute: CustomRoutes.SHIPMENT_CREDIT_CLAIM_HISTORY,
        params: { code: this.dispenserShipmentId }
        //Sagar
        // }, null, {queryParams: {page: page}});
      },
      { queryParams: { page: page } }
    )

    this.selectedPage = page
    this.changePageData({
      pageNumber: this.selectedPage,
      status: this.selectedFilter,
      searchText: this.selectedSearch
    })
  }

  changePageData(params: ISharedPagination): void {
    this.showLoaderOnPagination = true
    this.shipmentCreditClaimService
      .getEntries(this.dispenserShipmentId, params)
      .pipe(
        finalize(() => {
          this.showLoaderOnPagination = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe((res) => {
        if (!res) {
          this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
        } else {
          this.entries = res
        }
      })
  }

  downloadCSV(): void {
    this.downloadingCsv = true
    const csv: ICsv = {
      title: `Credit History`,
      columns: [
        { title: 'dispenserShipment.id', key: 'code' },
        { title: 'dispenserShipment.creditMemo', key: 'orderDocument' },
        { title: 'dispenserShipment.agreementNumber', key: 'quote.orderCode' },
        { title: 'dispenserShipment.date', key: 'shipmentOrderDate', type: CustomTableColumnType.DATE },
        { title: 'dispenserShipment.type', key: 'type' },
        { title: 'shared.status', key: 'status' },
        { title: 'dispenserShipment.netValue', key: 'netValue.formattedValue' },
        { title: 'dispenserShipment.gst', key: 'gst.formattedValue' }
      ],
      rows: this.entries?.results
    }
    this.downloadingCsv = false
    this.csvService.generateCSV(csv)
    this.changeDetectorRef.detectChanges()
  }

  public downloadCreditNote(documentId: string): void {
    if (!documentId) {
      return
    }

    this.documentService
      .getDocumentByNumber(documentId)
      .subscribe((res) => this.shipmentCreditClaimService.generateCreditNote(res))
  }
}
